import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dd904e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "width", "height"]
const _hoisted_2 = { class: "game-over-btn-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "end__progress-bar" }

import { useUserStore } from '@/stores/userStore';
import ProgressCircle from '@/components/ProgressCircle.vue';
import ProgressComponent from '@/components/ProgressComponent.vue';
import { getLeaderboard } from '@/services/leaderboardService';
import { onBeforeMount, onBeforeUnmount, onMounted, ref } from 'vue';
import { ROUTES } from '@/router/routes';
import EndLayoutComponent from '@/components/EndLayoutComponent.vue';
import { isPhone } from '@/utils/responsiveHelper';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'GameEndView',
  setup(__props) {

const userStore = useUserStore();
const leaderboardLength = ref(0);
const userRank = ref(0);

async function calcUserRank() {
  const leaderboard = await getLeaderboard();

  if (leaderboard.data) {
    leaderboardLength.value = leaderboard.data?.length || 0;
    userRank.value =
      leaderboard.data.findIndex((element) => element[0] === userStore.id) + 1;
  }
}

onBeforeMount(async () => await calcUserRank());

let timer: number;

function startTimer() {
  timer = setInterval(() => {
    router.push(ROUTES.END_MENU);
  }, 5000);
}
function stopTimer() {
  clearInterval(timer);
}

onMounted(startTimer);
onBeforeUnmount(stopTimer);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("img", {
      src: require('@/assets/images/moaf-logo.svg'),
      width: _unref(isPhone)() ? '100' : '245',
      height: _unref(isPhone)() ? '100' : '245',
      alt: "logo",
      class: "icon-wrapper"
    }, null, 8, _hoisted_1),
    _createVNode(EndLayoutComponent, { class: "layout" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ProgressCircle, {
            score: _unref(userStore).score
          }, null, 8, ["score"]),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_unref(userStore).name ?? 'Invisible Fairy') + ", ", 1),
            _hoisted_3,
            _createTextVNode(" you rank " + _toDisplayString(userRank.value) + " out of " + _toDisplayString(leaderboardLength.value) + ". 🏆 ", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ProgressComponent, {
            autoStart: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(_unref(ROUTES).GAME_OVER)))
          }),
          _createVNode(ProgressComponent, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(_unref(ROUTES).END_MENU)))
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})